import React, { useEffect } from 'react';
import Fliter, { FliterForm } from '../../../components/table/fliter/Fliter';
import Selector from '../../../components/from/selector/Selector';
import { connect } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { ILines } from '../../../redux/progress/line/lineReducer';
import { setActiveLine, updateLines } from '../../../redux/progress/line/lineAction';
import { setRunningIndex, setActiveModule, updateModule } from '../../../redux/progress/module/moduleAction';
import { updateParam, clearParam } from '../../../redux/progress/param/paramAction';
import { jobnameUpdate } from '../../../redux/progress/jobname/jobnameAction';
import '../header/ProgressHeader.css'
// import useUpdateParam from './useUpdateParam';
import { IModuleParams } from '../../../redux/progress/param/paramReducer';
import { IJobListen } from '../../../redux/progress/job/jobReducer';
import { refreshJobs } from '../../../redux/progress/job/jobAction';
import { IJobName } from '../../../redux/progress/jobname/jobnameReducer';
import { IState } from '../../../redux/store';
import { IModule } from '../../../redux/progress/module/moduleReducer';
import useUpdateLine from '../header/useLine';
import useUpdateParam from '../header/useUpdateParam';
import { useUpdateModule } from '../ResonanceModule/moudleList/useUpdateModule';
import { IModuleInfo } from '../../../redux/progress/module/moduleInterface';
import { speciality } from '../../../config/technology';
import FormText from '../../../components/from/text/FormText';

function RealTimeHeader(props: {
    userName: string,
    activeProjectName: string
    lines: ILines;
    activeLine: string;
    modules: IModule;
    activeIndex: number,
    setActiveLine: (name: string) => void,
    updateLines: (lines: ILines) => void,
    updateParam: (param: IModuleParams) => void,
    setRunningIndex: (runningIndex: number) => void,
    setActiveModule: (activeindex: number) => void,
    refreshJobs: (jobs: IJobListen) => void,
    jobnameUpdate: (jobnames: IJobName) => void,
    clearParam: () => void,
    updateModule: (modules: IModuleInfo[]) => void,
}) {


    const { spec, tech } = useParams<{ spec: string, tech: string }>();
    const updateLines = useUpdateLine(props.userName, props.activeProjectName, props.updateLines, tech);
    const updateModuleNetWork = useUpdateModule();
    // const history = useHistory();

    useEffect(() => {
        updateModuleNetWork().then(modules => {
            props.updateModule(modules);
        })
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [spec]);

    const updateParam = useUpdateParam(
        props.userName,
        props.activeProjectName,
        props.activeLine,
        props.updateParam,
        props.setRunningIndex,
        props.refreshJobs,
        props.setActiveModule,
        tech,
        props.jobnameUpdate,
        props.modules,
        ''
    );

    useEffect(() => {
        updateLines();
    }, [props.userName, props.activeProjectName]); // eslint-disable-line

    useEffect(() => {
        props.clearParam();
        updateParam();
    }, [props.activeLine]); // eslint-disable-line


    const moduleSelectObject: { [key in number]: string } = {};
    props.modules.modules.forEach((module, index) => {
        moduleSelectObject[index] = module.PRO_MODULE_ALIASNAME;
    })


    return (
        <Fliter className="progress-header">
            <FliterForm>
                {/* <Selector
                    titleId="计算类别"
                    id="spec"
                    object={speciality}
                    onChange={(val) => {
                        history.push(`/${props.userName}/progress/${val}/rtcompute`);
                    }}
                    value={spec}
                />
                <Selector
                    titleId="模块列表"
                    id="model"
                    object={moduleSelectObject}
                    onChange={(some) => {
                        console.log(some);
                        props.setActiveModule(some);
                    }}
                    value={props.modules.activeIndex}
                /> */}
                <FormText titleId="progress_category_header" id="progress_category_header" value={spec} />
                <FormText titleId="module_category" id="module_category" value={tech} />
                <Selector
                    titleId="line"
                    id="line"
                    object={props.lines}
                    defaultValue={{ value: "new_line" }}
                    onChange={props.setActiveLine}
                    value={props.activeLine}
                />
            </FliterForm>
        </Fliter>
    )
}

const mapStateToProps = (state: IState) => {
    return {
        userName: state.user.userName,
        activeProjectName: state.project.activeName,
        lines: state.progress.line.lines,
        activeLine: state.progress.line.activeName,
        modules: state.progress.modules,
        activeIndex: state.progress.modules.activeIndex,
    };
};

export default connect(
    mapStateToProps,
    { setActiveLine, updateLines, updateParam, setRunningIndex, refreshJobs, setActiveModule, jobnameUpdate, clearParam, updateModule }
)(RealTimeHeader)